module.exports = __webpack_public_path__ + "static/dash-1-cc52cc7dacb0c8bf7284146f5094f5f2.png";